import { EllipsisHorizontalCircleIcon } from '@heroicons/react/24/outline'
import React from 'react'
import { Menu, MenuHandler, MenuList, MenuItem, Button } from "@material-tailwind/react";
import { Link } from 'react-router-dom';

const WarehouseTable = ({ warehouseList, deleteWarehouse }) => {
  return (
    <div className='overflow-hidden rounded-[24px] border border-slate-200 bg-white shadow-[0_18px_42px_rgba(15,23,42,0.07)]'>
      <div className='overflow-x-auto'>
        <table className='min-w-full border-separate border-spacing-0'>
          <thead>
            <tr className='bg-[#fffaf6]'>
              <th className='border-b border-slate-200 px-5 py-4 text-left text-xs font-[GilroyBold] uppercase tracking-[0.14em] text-[#bf7b52]'>Client Name</th>
              <th className='border-b border-slate-200 px-5 py-4 text-left text-xs font-[GilroyBold] uppercase tracking-[0.14em] text-[#bf7b52]'>Company Name</th>
              <th className='border-b border-slate-200 px-5 py-4 text-left text-xs font-[GilroyBold] uppercase tracking-[0.14em] text-[#bf7b52]'>Pin Code</th>
              <th className='border-b border-slate-200 px-5 py-4 text-left text-xs font-[GilroyBold] uppercase tracking-[0.14em] text-[#bf7b52]'>City</th>
              <th className='border-b border-slate-200 px-5 py-4 text-left text-xs font-[GilroyBold] uppercase tracking-[0.14em] text-[#bf7b52]'>State</th>
              <th className='border-b border-slate-200 px-5 py-4 text-left text-xs font-[GilroyBold] uppercase tracking-[0.14em] text-[#bf7b52]'>Country</th>
              <th className='border-b border-slate-200 px-5 py-4 text-left text-xs font-[GilroyBold] uppercase tracking-[0.14em] text-[#bf7b52]'>Contact</th>
              <th className='border-b border-slate-200 px-5 py-4 text-left text-xs font-[GilroyBold] uppercase tracking-[0.14em] text-[#bf7b52]'>Phone</th>
              <th className='border-b border-slate-200 px-5 py-4 text-center text-xs font-[GilroyBold] uppercase tracking-[0.14em] text-[#bf7b52]'>Action</th>
            </tr>
          </thead>
          <tbody>
            {warehouseList?.length ? warehouseList.map((item) => (
              <tr key={item.id} className='transition-colors hover:bg-slate-50/70'>
                <td className='border-b border-slate-100 px-5 py-4 text-[13px] font-[GilroyBold] text-slate-900'>{item?.pickupName?.name || '-'}</td>
                <td className='border-b border-slate-100 px-5 py-4 text-[13px] font-[GilroyMedium] text-slate-700'>{item?.pickupName?.companyName || '-'}</td>
                <td className='border-b border-slate-100 px-5 py-4 text-[13px] font-[GilroyMedium] text-slate-700'>{item.pinCode || '-'}</td>
                <td className='border-b border-slate-100 px-5 py-4 text-[13px] font-[GilroyMedium] text-slate-700'>{item.city || '-'}</td>
                <td className='border-b border-slate-100 px-5 py-4 text-[13px] font-[GilroyMedium] text-slate-700'>{item.state || '-'}</td>
                <td className='border-b border-slate-100 px-5 py-4 text-[13px] font-[GilroyMedium] text-slate-700'>{item.country || '-'}</td>
                <td className='border-b border-slate-100 px-5 py-4 text-[13px] font-[GilroyMedium] text-slate-700'>{item.personName || '-'}</td>
                <td className='border-b border-slate-100 px-5 py-4 text-[13px] font-[GilroyMedium] text-slate-700'>{item.phone || '-'}</td>
                <td className='border-b border-slate-100 px-5 py-4 text-center align-middle'>
                  <Menu placement="bottom-end">
                    <MenuHandler>
                      <Button variant="text" className='rounded-full p-1.5 text-slate-600 shadow-none hover:bg-slate-100'>
                        <EllipsisHorizontalCircleIcon className="h-5 w-5" />
                      </Button>
                    </MenuHandler>
                    <MenuList>
                      <Link to={`/editwarehouse/${item.id}`} className='text-left'><MenuItem>Edit</MenuItem></Link>
                      <MenuItem onClick={() => deleteWarehouse(item.id)} className='text-red-600'>Delete</MenuItem>
                    </MenuList>
                  </Menu>
                </td>
              </tr>
            )) : (
              <tr>
                <td colSpan={9} className='px-5 py-16 text-center'>
                  <p className='text-base font-[GilroyMedium] text-slate-500'>No warehouses found</p>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default WarehouseTable
